import * as React from "react";
import { forwardRef } from "react";
const SvgMinimize = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.5 20H11.5L11.5 4H9.5L9.5 20ZM4.5 8L3.09 9.41L4.67 11H1.5V13H4.69L3.11 14.61L4.5 16L8.5 12L4.5 8ZM14.5 20L14.5 4H12.5L12.5 20H14.5ZM19.5 16L20.89 14.61L19.31 13H22.5V11H19.33L20.92 9.41L19.5 8L15.5 12L19.5 16Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgMinimize);
export { ForwardRef as ReactComponent };
